import { useState, useEffect } from "react";
import GuestRepository from "../core/repository/QuizeRepository";

export const useQuizFolders = () => {
  const [folders, setFolders] = useState([]);
  const [loadingFolders, setLoadingFolders] = useState(false);

  const loadDirectoryFolders = async () => {
    setLoadingFolders(true);
    try {
      const response = await GuestRepository.fetchQuizFolder();
      if (response && !response.error) {
        const directoryData = response?.data?.quiz_directories || response?.quiz_directories;
        setFolders(directoryData ? { quiz_directories: directoryData } : []);
      }
    } catch (error) {
      console.error("Error loading quiz folders:", error);
    } finally {
      setLoadingFolders(false);
    }
  };

  useEffect(() => {
    loadDirectoryFolders();
  }, []);

  return { folders, loadingFolders, refreshFolders: loadDirectoryFolders };
};